// 6 digit numbers - because product id from backend also has 6

export const randomNumberGenerator = () => {
  return Math.floor(100000 + Math.random() * 900000)
}
